export default "__VITE_ASSET__9FEW0JD___"